import { render, staticRenderFns } from "./NewsSearchIndex.vue?vue&type=template&id=925a95f6"
import script from "./NewsSearchIndex.vue?vue&type=script&lang=js"
export * from "./NewsSearchIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports